<template>
    <div class="w-full">
        <v-text-field
            :model-value="formatDate"
            @update:model-value="onTextFieldValueChanged"
            :append-inner-icon="readonly || noMenu ? '' : '$oss-calendar'"
            @click:append-inner.stop="readonly || disabled || noMenu ? null : (dateDialog = true)"
            @click="openDialogFromTextField"
            @keypress="onKeyPress($event)"
            @keydown="handleKeydown"
            @close="textFieldValue = ''"
            :readonly="textFieldReadOnly || readonly"
            :disabled="disabled"
            :mandatory="mandatory"
            :outlined="outlined"
            :label="label"
            :placeholder="placeholder"
            :hide-details="hideDetails"
            :rules="[() => isValid()]"
            :data-cy="prefixDataCy ? prefixDataCy + 'date' : 'date'"
            :class="fullTextFieldClass"
            :error="error"
            :autofocus="autofocus"
            :hint="hint"
            :persistent-hint="persistentHint"
            @mouseout="onMouseOut"
            @mouseover="onMouseOver"
            v-if="!hideActivator"
            :tabindex="tabindex"
            :show-current="showCurrent"
            :density="dense ? 'compact' : 'default'"
            style="min-width: 150px"
            :required="required"
        />
        <oss-dialog
            ref="dateDialog"
            v-model="dateDialog"
            persistent
            width="450px"
            @close="close()"
            :without-header="true"
        >
            <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-center">
                    <v-date-picker-wrapper
                        v-model="localDate"
                        @update:model-value="onDatePickerValueChanged"
                        v-bind="pickerProps"
                        :type="type"
                        scrollable
                        hide-header
                        :min="minDate"
                        :max="maxDate"
                        :allowed-dates="allowedDates"
                        first-day-of-week="1"
                        :range="Array.isArray(internalValue)"
                        :data-cy="prefixDataCy + '-calendar'"
                    />
                </v-col>
            </v-row>

            <template v-slot:actions>
                <v-btn-primary
                    block
                    @click="emitDate()"
                    :data-cy="prefixDataCy + '-date-ok'"
                    size="large"
                    >OK</v-btn-primary
                >
            </template>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { Component, toNative } from "vue-facing-decorator";
import { ossDatePickerBase } from "./OssDatePickerBase";

@Component
export class ossDatePicker extends ossDatePickerBase {}

export default toNative(ossDatePicker);
</script>

<style scoped>
.v-input__slot {
    padding-left: 12px;
}
</style>
